export class InventoryItemViewModel {
  cpuModel: string = "";
  diskDriveSize: number = 0;
  diskDriveUnit: string = "";
  diskDriveType: string = "";
  imageLocation: string = "";
  manufactureName: string = "";
  manufacturePartNum: string = "";
  materialID: string = "";
  memorySize: number = 0;
  memoryUnit: string = "";
  name: string = "";
  osType: string = "";
  productDescLong: string = "";
  productDescShort: string = "";
  productLine: string = "";
  productType: string = "";
  screenSize: string = "";
  vendorURL: string = "";
  id: string = "";
  constructor() {
  }
}
